import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons";
import {faCheckCircle} from "@fortawesome/free-regular-svg-icons";
import ReportButtons from "./../controls/report-buttons";
import React, {useContext, useEffect} from "react";
import './style.css'
import {AuthContext} from "../contexts/auth.context";
import {ReportCategory} from "../types";

const BASE_URL = (window as any).REPORT_API_URL;

export interface DetailsProps {
    action: ReportCategory | null;
}

const Details = ({action}: DetailsProps) => {
    const {info} = useContext(AuthContext);
    const [selectedCategory, setSelectedCategory] = React.useState<string>('');
    const [reported, setReported] = React.useState<boolean>(false);
    const [reporting, setReporting] = React.useState<boolean>(false);

    const onSelected = (category: string) => {
        setSelectedCategory(category);
    }

    const report = React.useCallback((category: ReportCategory) => {
        const reportData = {
            "reportCategory": category,
            "emailId": info?.userInformation?.magicLinkAppInfo.emailId,
            "emailChildId": info?.userInformation?.magicLinkAppInfo.emailChildId,
            "emailReceivedAt": info?.userInformation?.magicLinkAppInfo.emailTimestamp,
            "tenantId": info?.userInformation?.magicLinkAppInfo.tenantId,
        }
        setReporting(true)
        fetch(`${BASE_URL}/cybergraph/v1/report`, {
            method: 'POST', body: JSON.stringify(reportData), headers: new Headers({
                "Authorization": `Bearer ${info?.token}`, "Content-Type": "application/json"
            })
        }).then(res => {
            if (res.ok) {
                setReported(true);
            }
            setReporting(false);
        }, (error) => {
            setReporting(false);
            console.log(error)
        });
    }, [info]);


    //if action is not null, then report
    useEffect(() => {
        if (action) {
            setSelectedCategory(action);
            report(action);
        }
    }, [action, report])

    const  getReportedMessage = () => {
        if (selectedCategory === 'safe') {
            return 'You won’t get warnings for this sender in future.';
        } else {
            return 'You can now move the message to your junk folder. We’ll keep sending warnings for this sender.'
        }
    }

    return (<>
        {(reported && <>
            <div className="box reported">
                <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>
                <div className="report-title">You marked this message as {selectedCategory}</div>
                <div className="subtitle">Your feedback helps make email safer for everyone!</div>
                <div className="field">{getReportedMessage()}</div>
            </div>

        </>)}
        {(!reported && !action && <>
            <div className="box">
                <div className="report-title">This message needs your attention</div>
                <div className="row">
                    <FontAwesomeIcon size='3x' icon={faUserCircle} color='#999999'
                                     className={"avatar"}/>
                    <div className="column">
                        <div
                            className="field from">{info?.userInformation?.magicLinkAppInfo.sender}</div>
                        <div className="field">
                            <div className="label">Subject:</div>
                            <div className="value">{info?.userInformation?.magicLinkAppInfo.subject}</div>
                        </div>
                        <div className="field">
                            <div className="label">To:</div>
                            <div className="value">{info?.userInformation?.magicLinkAppInfo.recp}</div>
                        </div>
                    </div>
                </div>
                <div className="report-subtitle-title">What do you want to do with this message?</div>
                <div className={reporting ? 'disabled' : ''}>
                    <ReportButtons onSelected={onSelected}></ReportButtons>
                </div>
                <div className="row footer">
                    {reporting && <div className='spinner'></div>}
                    <button disabled={selectedCategory === '' || reporting}
                            onClick={() => report(selectedCategory as ReportCategory)}
                            className="submit"> Submit
                    </button>
                </div>
            </div>
        </>)}
    </>);
};
export default Details;
